import React from 'react'

const IconPlay = ({
    size
}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10.6667V13.3333C7 16.3105 7 17.799 7.97101 18.3817C8.94202 18.9643 10.2555 18.2638 12.8824 16.8627L15.3824 15.5294C18.2941 13.9765 19.75 13.2 19.75 12C19.75 10.8 18.2941 10.0235 15.3824 8.47059L12.8824 7.13725C10.2555 5.73625 8.94202 5.03574 7.97101 5.61835C7 6.20095 7 7.68952 7 10.6667Z" fill="white" />
        </svg>

    )
}

export default IconPlay
